"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _BrixelIcon = _interopRequireDefault(require("./BrixelIcon"));
var _useCopyToClipboard = require("../hooks/useCopyToClipboard");
var _BrixelTooltip = _interopRequireDefault(require("./BrixelTooltip"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const BrixelButtonContactIcon = ({
  action,
  className = '',
  data,
  icon,
  color = 'Text200'
}) => {
  const textToCopy = () => {
    switch (icon) {
      case 'phone':
        return `tel:${data}`;
      case 'mail':
        return `mailto:${data}`;
      default:
        return '';
    }
  };
  const {
    isCopied,
    copyToClipboard
  } = (0, _useCopyToClipboard.useCopyToClipboard)({
    content: textToCopy()
  });
  const openAction = () => {
    switch (icon) {
      case 'phone':
        window.open(`tel:${data}`, '_blank');
        break;
      case 'mail':
        window.open(`mailto:${data}`, '_blank');
        break;
      default:
        return '';
    }
  };
  return /*#__PURE__*/_react.default.createElement("button", {
    className: `brdFullRadius brdSmall w-fix-32 h-fix-32 dis-f a-c jc-c txt${color} brd${color} ${className}`
  }, /*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    icon: icon,
    iconSize: 'w-fix-16 h-fix-16',
    onClick: () => action === 'copy' ? copyToClipboard() : openAction()
  }), isCopied && (/*#__PURE__*/_react.default.createElement(_BrixelTooltip.default, {
    defaultShowTooltip: true,
    description: "Copied!",
    width: "auto"
  })));
};
var _default = exports.default = BrixelButtonContactIcon;